import api from '@/modules/api'
import { mutationNames } from '@/store/storeKey'
const state = {
  customCode: {
    'Id': '',
    'SubscriptionModule_Id': 0,
    'PageTitle': '',
    'RowCreated': '',
    'RowUpdated': '',
    'CustomCodeHTML': '',
    'CustomCodeCSS': '',
    'CustomCodeJavaScript': ''
  }
}
const getters = {
  CustomCode: state => state.customCode
}
const mutations = {
  [mutationNames.SET_CUSTOMCODE] (state, payload) {
    state.customCode = payload
  },
  [mutationNames.UPDATE_CUSTOMCODE] (state, payload) {
    Object.assign(state.customCode, payload)
  }
}
const actions = {
  updateCustomCode ({ commit, getters }, payload) {
    commit(mutationNames.UPDATE_CUSTOMCODE, payload)
  },
  async getCustomCodeInfo ({ commit, getters }, SubscriptionModuleId) {
    const response = await api.AppModules.GetCustomCodeInfo(SubscriptionModuleId)
    commit(mutationNames.SET_CUSTOMCODE, response)
  },
  async saveCustomCode ({ commit, dispatch, getters }) {
    let CustomCodeClone = Object.assign({}, getters.CustomCode)
    // commit(mutationNames.UPDATE_CODEEDITOR, CodeEditorClone)
    await api.AppModules.SaveCustomCodeInfo(CustomCodeClone)
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/store/appModules/customCode.js